module.exports = {"name":"chromecast","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.1","built":"2018-03-12","repo":"https://bitbucket.org/npaw/chromecast-adapter-js","libVersion":"^6.1.13","features":{"buffer":"native","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getRendition","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 27
// module chunks = 0